module.exports = __webpack_public_path__ + "img/line-xs.6732a71f.svg";